export const TALES_COLORS = {
  accent: {
    100: "#E4B595",
    200: "#B17C58",
    300: "#97613C",
    400: "#764727",
    500: "#67320E",
    600: "#4D250A",
    700: "#391C08",
    800: "#251205",
    900: "#1A0A00",
  },
  primary: {
    100: "#C0DCEA",
    200: "#C0DCEA",
    300: "#A0D7F4",
    400: "#81CEF7",
    500: "#53C2FD",
    600: "#2CA3E2",
    700: "#1786C0",
    800: "#096EA5",
    900: "#035079",
  },
  secondary: {
    100: "#C4DAEB",
    200: "#A0C4DF",
    300: "#69A3CE",
    400: "#3E92D1",
    500: "#1B84D3",
    600: "#1568A6",
    700: "#115384",
    800: "#0B3656",
    900: "#02243D",
  },

  lightYellow: {
    100: "#FFF2D1",
    200: "#FFEEC3",
    300: "#FFE7AA",
    400: "#FFE39E",
    500: "#FDDA82",
    600: "#F2C963",
    700: "#E3B648",
    800: "#C89B2B",
    900: "#BD8B0D",
  },
  yellow: {
    100: "#FFFCF4",
    200: "#FFF4D5",
    300: "#FFEAB1",
    400: "#FFDA74",
    500: "#FBC42D",
    600: "#DAA719",
    700: "#BD8E0A",
    800: "#9F7704",
    900: "#826000",
  },
  white: "#FFFFFF",
  black: "#251205",
  darkEye: "#729EA5",
  lightEye: "#ADDAE0",
  background: "#A0D4F0",
  text: "#251205",
  pink: "#E41099",
};
